import React, { Component } from "react";
import { withRouter } from "react-router";
import covercolor1 from "../../../assets/images/cover_color_1.png";
import covercolor2 from "../../../assets/images/cover_color_2.png";

import Personalize from "../../../components/common/Personalize/Personalize";
import mixins from "../../../app-services/mixins";

export const RowWrapper = (props) => (
  <div className="row no-gutters">
    <div className="col"></div>
    {props.children}
    <div className="col"></div>
  </div>
);

export class Dedication extends Component {
  constructor(props) {
    super(props);
    initialConstruct.bind(this)("Dedication");
    this.state = {
      dedicationLenght:
        this.props.store?.customCharacter[8]?.ans?.dedication.length,
      dedicationStyle:
        this.props.store?.customCharacter[8]?.ans?.dedication.length == 125
          ? { color: "red" }
          : { color: "#000000" },
      dedicationText:
        this.props.store?.customCharacter[8]?.ans?.dedication ||
        `<p>Believe in yourself</p> <p>and dare to dream!</p> <p>You are always loved.</p>`,
    };
  }

  setDedication(value) {
    let datatext = mixins.convertToHtmlEntities(value);
    let { onAnswer = () => "" } = this.props;
    AppLayout.setStore("customCharacter.8.ans", { dedication: datatext });
    onAnswer(value, "dedication");
  }
  defaultDedication() {
    if (!this.props.store?.customCharacter[8]?.ans?.dedication) {
      let { onAnswer = () => "" } = this.props;
      AppLayout.setStore("customCharacter.8.ans", {
        dedication: `<p>Believe in yourself</p> <p>and dare to dream!</p> <p>You are always loved.</p>`,
      });
      onAnswer(value, "dedication");
    }
  }
  render() {
    let me = this;
    let { onSave = () => "" } = this.props;
    let { dedicationLenght, dedicationStyle, dedicationText } = this.state;
    function convertPtoNewlines(html) {
      if (/<p.*?>/i.test(html)) {
        // Replace <p> and </p> with newlines, trim spaces
        return html
          .replace(/<\/p>\s*<p>/gi, "\n") // Replace between paragraphs
          .replace(/<\/?p>/gi, "") // Remove <p> and </p> tags
          .trim(); // Clean up extra spaces/newlines
      }
      return html; // If no <p> tags, return as-is
    }
    const dedicationAllowedCharacters = /^[a-zA-Z0-9\s.,!?'"()&:;]+$/;
    function removeSpecialCharacters(value) {
      return value.replace(/[^a-zA-Z0-9\s.,!?'"()&:;]/g, "");
    }
    function sanitizeDedicationInput(e) {
      mixins.preventEmoji(e);
      e.target.value = removeSpecialCharacters(e.target.value);
      return e.target.value;
    }
    function blockSpecialCharacters(e) {
      if (e.data && !dedicationAllowedCharacters.test(e.data)) {
        e.preventDefault();
      }
    }
    function setDedicationLengthStyle(value) {
      this.setState({
        dedicationLenght: value.length,
        dedicationStyle:
          value.length == 125 ? { color: "red" } : { color: "#000" },
      });
    }
    function handleDedicationPaste(e) {
      e.preventDefault();
      const textArea = e.target;
      const pastedText = removeSpecialCharacters(
        e.clipboardData.getData("text"),
      );
      const start = textArea.selectionStart;
      const end = textArea.selectionEnd;
      const nextValue =
        `${textArea.value.slice(0, start)}${pastedText}${textArea.value.slice(end)}`.slice(
          0,
          125,
        );

      textArea.value = nextValue;
      setDedicationLengthStyle.call(this, nextValue);
      me.debounce(e, me.setDedication, "setDedication");
    }
    return (
      <RowWrapper>
        <div className="col-lg-10 pt-2 dedication-container">
          <label className="bold-header">Write a special message here:</label>
          <p
            style={{
              color: "red",
              fontSize: "12px",
            }}
          >
            We’ll print exactly what you’ve typed, so do double-check! Please
            only use letters, numbers and keyboard characters (no emojis)
          </p>
          <div>
            <textarea
              maxLength={125}
              defaultValue={convertPtoNewlines(dedicationText)}
              onBeforeInput={blockSpecialCharacters}
              onInput={(e) => {
                sanitizeDedicationInput(e);
                me.debounce(e, me.setDedication, "setDedication");
              }}
              onPaste={(e) => handleDedicationPaste.call(this, e)}
              onChange={(e) => {
                const value = sanitizeDedicationInput(e);
                setDedicationLengthStyle.call(this, value);
              }}
            ></textarea>
          </div>
          <span style={{ fontSize: "14px", ...dedicationStyle }}>
            {dedicationLenght ? dedicationLenght : dedicationText.length}/125
          </span>
          <div>
            <button
              className="savebtn"
              onClick={() => {
                onSave();
              }}
            >
              Save
            </button>
          </div>
        </div>
      </RowWrapper>
    );
  }
}

export class CoverOptions extends Component {
  constructor(props) {
    super(props);
    initialConstruct.bind(this)("CoverOptions");
    this.state = {
      selected: "Hard Cover",
      options: [
        {
          cover: covercolor1,
          value: "Hard Cover",
          label: "Hard Cover",
          price: "13.90",
        },
        {
          cover: covercolor2,
          value: "Soft Cover",
          label: "Soft Cover",
          price: "13.90",
        },
      ],
    };
  }

  selectCover(obj) {
    let { options } = this.state;
    let { onAnswer = () => "" } = this.props;
    onAnswer(obj.value, "cover");
    //console.log({ selectCover: obj });
    this.setState({
      selected: obj.value,
      options: [...options],
    });
  }

  componentDidMount() {
    let { onAnswer = () => "" } = this.props;
    let { selected } = this.state;
    onAnswer(selected, "cover");
  }

  render() {
    let me = this;
    return (
      <RowWrapper>
        <div className="col-lg-10 pt-2 cover-container">
          {me.state.options.map((obj, i) => (
            <div onClick={(e) => me.selectCover(obj, i)} key={i}>
              <img src={obj.cover}></img>
              <div>
                <input
                  type={"checkbox"}
                  name="cover"
                  value={obj.value}
                  checked={me.state.selected == obj.value}
                  onChange={(e) => e.preventDefault()}
                ></input>
                <label>{obj.label}</label>
              </div>
            </div>
          ))}
        </div>
      </RowWrapper>
    );
  }
}

export class HandprintSave extends Component {
  render() {
    let { onSave = () => "", bookname } = this.props;
    return (
      <RowWrapper>
        {bookname == "handprint-book" && (
          <div className="col-lg-10 pt-2 dedication-container">
            <div>
              {/* <button className="savebtn" onClick={() => onSave()}>
                Save
              </button> */}
            </div>
          </div>
        )}
      </RowWrapper>
    );
  }
}

export const CheckoutFlow = [
  {
    name: "coveroption",
    subheading: "Select your Cover Page",
    Component: connect(withRouter(CoverOptions)),
    label: "Choose Your Cover Page",
  },
  {
    name: "edit",
    subheading: "Customisations",
    Component: connect(withRouter(HandprintSave)),
    label: "Edit name and make changes",
    onClick: () => {
      Modal.state.list.find((o) => o.type == "model").close();
      document.querySelector("#editBook")?.click();
    },
  },
  {
    name: "dedication",
    subheading: "Dedication",
    Component: connect(withRouter(Dedication)),
    label: "Write a personal note",
  },
];
export default CheckoutFlow;
